// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1GIlr","header":"ReportDetails_header__29-l6","title":"ReportDetails_title__R7bmh","left":"ReportDetails_left__365Sy"};